"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Audience = void 0;
const Node_1 = require("./Node");
class Audience {
    constructor(data) {
        this.label = 'Audience';
        this.id = null;
        this.name = null;
        this.type = 'timeline';
        this.isInCatalog = false;
        this.modifier = '0';
        this.adverts = [];
        this.createdAt = null;
        this.updatedAt = null;
        this.nominativeGroupFlag = 0;
        this.relationships = [];
        this.categories = {};
        this.groupedRelationships = {};
        this._model = "1.1";
        this.area = null;
        this.isUsed = null;
        this.author = null;
        if (data) {
            this.id = data.id;
            this.name = data.name;
            this.type = data.type;
            this.isInCatalog = data.isInCatalog || false;
            this.modifier = (data.modifier === null) ? '0' : data.modifier;
            this.adverts = (typeof data.adverts !== 'undefined') ? data.adverts : [];
            this.relationships = (typeof data.relationships !== 'undefined') ? data.relationships : [];
            this.categories = (typeof data.categories !== 'undefined') ? data.categories : {};
            this.nominativeGroupFlag = (typeof data.nominativeGroupFlag !== 'undefined') ? data.nominativeGroupFlag : 0;
            this.groupedRelationships = this.computeGroups();
            this.createdAt = (typeof data.createdAt !== "undefined") ? parseInt(data.createdAt) : null;
            this.updatedAt = (typeof data.updatedAt !== "undefined") ? parseInt(data.updatedAt) : null;
            this.area = data.area || null;
            this.isUsed = data.isUsed || false;
            this.author = data.author || null;
            if (typeof data._model === "string") {
                this._model = data._model;
            }
        }
        this.adverts.sort(function (a, b) {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        });
    }
    toNode() {
        return new Node_1.Node(this);
    }
    computeGroups() {
        const groups = {};
        this.groupedRelationships = [];
        this.relationships.sort(function (a, b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        for (const i in this.relationships) {
            const label = this.relationships[i].label;
            if (typeof groups[label] === 'undefined') {
                groups[label] = [];
            }
            groups[label].push(this.relationships[i]);
        }
        const ordered = {};
        Object.keys(groups).sort().forEach((key) => {
            ordered[key] = groups[key];
        });
        return ordered;
    }
}
exports.Audience = Audience;
//# sourceMappingURL=Audience.js.map